import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const monitoringWellListItemSchema = baseAssetWithTimeseriesSchema.extend({
  levee_crosssection: z.string().nullable() /* URL */,
  well_top_level: z.number().nullable(),
  well_bottom_level: z.number().nullable(),
  distance_along_crosssection: z.number().nullable(),
});

export type MonitoringWellListItem = z.infer<typeof monitoringWellListItemSchema>;

export const monitoringWellListSchema = paginatedSchema(monitoringWellListItemSchema);
export type MonitoringWellList = z.infer<typeof monitoringWellListSchema>;

export const monitoringWellSchema = monitoringWellListItemSchema;
export type MonitoringWell = z.infer<typeof monitoringWellSchema>;

export function useMonitoringWells(params = {}) {
  const url = combineUrlAndParams("/api/v4/monitoringwells/", params);
  return useParsedQuery<MonitoringWellList>(
    ["lizard-api-v4", "monitoringwells", url],
    () => fetchWithError(url),
    (json: unknown) => monitoringWellListSchema.parse(json)
  );
}

export function useMonitoringWell(id: number) {
  return useParsedQuery<MonitoringWell>(
    ["lizard-api-v4", "monitoringwells", id],
    () => fetchWithError(`/api/v4/monitoringwells/${id}/`),
    (json: unknown) => monitoringWellSchema.parse(json)
  );
}

export function useMultipleMonitoringWells(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "monitoringwells", id],
        fetchFunction: () => fetchWithError(`/api/v4/monitoringwells/${id}/`),
        parseFunction: (json: unknown) => monitoringWellSchema.parse(json),
      };
    })
  );
}
